import { Amplify } from "aws-amplify";
import { appEnv } from "../config/env";

export function configureAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        region: appEnv.cognito.region,
        userPoolId: appEnv.cognito.userPoolId,
        userPoolClientId: appEnv.cognito.userPoolClientId,
      },
    },
  });
}
